import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateItemGalleryEntity } from '../../domain/entities/CreateUpdateItemGalleryEntity'

export class CreateUpdateItemGalleryModel extends CreateUpdateItemGalleryEntity {
  constructor(dataDto: CreateUpdateItemGalleryEntity) {
    super()
    mapEntityProperties<CreateUpdateItemGalleryModel>(this, dataDto, {
      exclude: ['imageUrl', 'type']
    })
  }
}
